import { zenFetch } from '@zenlayer/portal-utils';
export function fetch(params) {
    return zenFetch.request(params).then((res) => {
        return res;
    });
}
export function request(params) {
    return fetch(params).then((res) => {
        const resD = res?.data ?? {};
        return resD;
    });
}
export const requestFactory = function (prefix) {
    return function (params) {
        return request({ ...params, url: prefix + params.url });
    };
};
